export default __webpack_public_path__ + "static/media/photo-1@2x.d3cd54e1.png";